import { SubVertical, Vertical } from 'common/constants'
import { StoreBrandFilterState } from 'common/types/state'
import { axios } from 'common/utils'
import { getHeaders } from 'common/utils/ajax/axios'

export async function fetchPersonalStoreBrands(
  vertical: Vertical,
  subVertical: SubVertical,
  menuId?: string,
  headers?: any,
): Promise<StoreBrandFilterState> {
  const path = subVertical === SubVertical.STYLE ? 'store' : 'brand'
  const result = await axios.get<StoreBrandFilterState>(
    `/v1/personalizeds/verticals/${vertical}/subverticals/${subVertical}/filters/${path}`,
    {
      ...getHeaders(headers),
      params: { menuId },
    },
  )

  return result && result.data
}
